import { Check, ArrowRight, Sparkles, Phone, Wallet } from "lucide-react";

const planFeatures = [
  "AI vocale italiana personalizzata sul tuo sito",
  "Risposte 24 ore su 24, 7 giorni su 7",
  "Email automatica al titolare dopo ogni chiamata",
  "Dashboard con storico chiamate e riassunti",
  "Aggiornamenti AI continui",
  "Supporto in italiano",
];

const topups = [
  { amount: "10€", label: "Ricarica piccola" },
  { amount: "20€", label: "Ricarica standard" },
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-brand-bg2 grain-bg" data-testid="pricing-section">
      <div className="max-w-5xl mx-auto px-6 md:px-8">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-olive uppercase mb-4 text-center">Prezzo</p>
        <h2 className="font-heading text-4xl md:text-5xl text-brand-ink mb-3 text-center leading-tight">
          Un prezzo onesto. Niente sorprese.
        </h2>
        <p className="text-center text-brand-inkSoft mb-12 max-w-2xl mx-auto">
          Paghi una volta l'anno per la piattaforma. Le chiamate le ricarichi solo quando ti servono.
        </p>

        <div className="grid md:grid-cols-5 gap-6 md:gap-8 items-stretch">
          {/* ============== ABBONAMENTO ANNUALE ============== */}
          <div
            className="md:col-span-3 bg-brand-ink text-brand-bg border border-brand-ink rounded-3xl p-8 md:p-10 shadow-xl relative flex flex-col"
            data-testid="pricing-card-yearly"
          >
            <div className="absolute -top-3 left-8 px-3 py-1 bg-brand-terra text-white text-xs font-semibold rounded-full uppercase tracking-wider flex items-center gap-1">
              <Sparkles className="w-3 h-3" />
              La piattaforma
            </div>

            <h3 className="font-heading text-2xl text-brand-bg mb-2">24Vox Annuale</h3>
            <div className="flex items-baseline gap-2 mb-1">
              <span className="font-heading text-5xl text-brand-bg">49€</span>
              <span className="text-brand-bg/60">/mese</span>
            </div>
            <p className="text-sm text-brand-bg/70 mb-1">
              fatturato annualmente · <span className="text-brand-terra font-medium">588€/anno</span>
            </p>
            <p className="text-xs text-brand-bg/60 mb-8">Pagamento unico annuale · nessun rinnovo a sorpresa</p>

            <ul className="space-y-3 mb-10 flex-1">
              {planFeatures.map((f, i) => (
                <li
                  key={i}
                  className="flex items-start gap-3 text-sm"
                  data-testid={`pricing-yearly-feature-${i + 1}`}
                >
                  <div className="w-5 h-5 rounded-full bg-brand-terra/20 flex items-center justify-center shrink-0 mt-0.5">
                    <Check className="w-3 h-3 text-brand-terra" strokeWidth={3} />
                  </div>
                  <span className="text-brand-bg">{f}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => (window.location.href = "/attivazione?piano=annuale")}
              className="bg-brand-terra hover:bg-brand-terra/90 text-white transition-colors w-full px-6 py-4 rounded-xl font-semibold flex items-center justify-center gap-2"
              data-testid="pricing-yearly-cta"
            >
              Attiva 24Vox
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>

          {/* ============== RICARICHE A CONSUMO ============== */}
          <div
            className="md:col-span-2 bg-white border border-brand-line rounded-3xl p-8 md:p-10 shadow-sm relative flex flex-col"
            data-testid="pricing-card-topup"
          >
            <div className="absolute -top-3 left-8 px-3 py-1 bg-brand-olive text-white text-xs font-semibold rounded-full uppercase tracking-wider flex items-center gap-1">
              <Wallet className="w-3 h-3" />
              Le chiamate
            </div>

            <h3 className="font-heading text-2xl text-brand-ink mb-2">Ricariche prepagate</h3>
            <p className="text-sm text-brand-inkSoft mb-8">
              Solo a consumo. Ricarichi quando vuoi, paghi solo le chiamate che ricevi.
            </p>

            <div className="space-y-3 mb-8 flex-1">
              {topups.map((t, i) => (
                <div
                  key={i}
                  className="flex items-center justify-between border border-brand-line rounded-xl px-5 py-4"
                  data-testid={`pricing-topup-${i + 1}`}
                >
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-brand-olive/10 flex items-center justify-center shrink-0">
                      <Phone className="w-4 h-4 text-brand-olive" />
                    </div>
                    <span className="text-sm text-brand-ink">{t.label}</span>
                  </div>
                  <span className="font-heading text-2xl text-brand-ink">{t.amount}</span>
                </div>
              ))}
            </div>

            <p className="text-xs text-brand-inkSoft leading-relaxed">
              Nessun canone sulle chiamate. Quando la ricarica finisce, ricarichi di nuovo. Tutto qui.
            </p>
          </div>
        </div>

        {/* Messaggio chiave */}
        <p
          className="font-heading text-2xl md:text-3xl text-brand-ink text-center mt-16 max-w-3xl mx-auto leading-tight"
          data-testid="pricing-key-message"
        >
          Nessun abbonamento a sorpresa.<br />
          <span className="text-brand-terra italic">Paghi una volta l'anno, ricarichi solo quando usi.</span>
        </p>
      </div>
    </section>
  );
}
